import { useEffect, useState } from 'react';

// Components
import Suites from './components/Suites.component';
import Units from './components/Units.component';

// Utils
import apiUrl from './utils/apiUrl';

// Sass
import './sass/main.scss';
import Nav from './components/Nav.component';
import Footer from './components/Footer.component';

function App() {
  const [suites, setSuites] = useState({ header: '', copy: '', steps: [] });
  const [units, setUnits] = useState([]);

  const fetchData = async () => {
    const data = await fetch(apiUrl).then(res => res.json());

    const { suites, units } = data;
     setSuites({ header: suites.header, copy: suites.copy, steps: suites.steps });
    const displayUnits = units.filter(unit => {
      if (unit.showUnit === 'Show') return unit;
    })
     setUnits(displayUnits);
}

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="App">
      <Nav />
        <div className="contentWrapper">
          <Suites header={suites.header} copy={suites.copy} steps={suites.steps} />
          <Units units={units} />
          <Footer />
        </div>
    </div>
  );
}

export default App;
